import React, {FC, ReactNode} from 'react'

import cn from 'classnames/bind'

import s from './ErrorMessage.module.scss'
const cx = cn.bind(s)

interface IErrorMessageProps {
	className?: string
	error: string | ReactNode | undefined
}

const ErrorMessage: FC<IErrorMessageProps> = ({className, error}) => {
	if (!error) return null
	return <p className={cx('wrapper', className)}>{error}</p>
}

ErrorMessage.displayName = 'ErrorMessage'

export default ErrorMessage
